import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ExpenseConsolConfigService {

  constructor(private http: HttpClient) { }

  /**
   * Load JSON from backend - used for lock check, code mast, GIE names, filing groups, saved config.
   * Action codes: n10cpv, lfmzzq, 9qgldf, gk7crv, qnr7oy
   */
  loadJsonObject(
    baseUrl: string,
    params: any,
    globalService: any = {}
  ): Observable<any> {
    let requestParams = _.merge({}, globalService || {}, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const queryString = urlEncoded.toString();
    const url = queryString
      ? `${baseUrl}/loadJsonObject?${queryString}`
      : `${baseUrl}/loadJsonObject`;

    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Save or delete Expense A&A pivot data - same endpoint as AngularJS ExpConsolFactory.
   * URL: saveJsonAsPivotObject?action_code=nc60wm
   */
  savePivotedData(
    baseUrl: string,
    clobSettingsObj: any,
    clobDataDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonAsPivotObject?action_code=nc60wm`;

    const g = globalService?.globalParams || globalService || {};
    const f = filterParams || {};

    // Build params matching exact payload structure
    const params: any = {};

    // clob_settings - contains scenario
    params.clob_settings = JSON.stringify(clobSettingsObj || {});

    // clob_data - the main data array
    params.clob_data = JSON.stringify(clobDataDetails || []);

    // Flat parameters
    params.tax_year = f.tax_year ?? g.tax_year ?? rowData.TAX_YEAR ?? '';
    params.screen_key = f.screen_key ?? g.screen_key ?? 379;
    params.scenario = f.scenario ?? g.scenario ?? 74;
    params.jcd_key = f.jcd_key ?? g.jcd_key ?? 250;
    params.jcd_ta_key = f.jcd_ta_key ?? g.jcd_ta_key ?? 1257;
    params.activity_key = f.activity_key ?? g.activity_key ?? 1450;
    params.screen_type = f.screen_type ?? g.screen_type ?? 'grid';
    params.is_locked = f.is_locked ?? g.is_locked ?? 'N';
    params.issue_id = f.issue_id ?? g.issue_id ?? '';
    params.issue_short_desc = f.issue_short_desc ?? g.issue_short_desc ?? '';
    params.issue_id_for_tx_save = f.issue_id_for_tx_save ?? g.issue_id_for_tx_save ?? '';
    params.checkLockedbj = JSON.stringify([{}]);
    params.scenarioCode = f.scenarioCode ?? g.scenarioCode ?? 'RAF';
    params.is_issue_key_enabled = f.is_issue_key_enabled ?? g.is_issue_key_enabled ?? 'N';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
